import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Cookies from 'js-cookie'
import axios from 'axios'
Vue.prototype.$axios = axios
Vue.config.productionTip = false

import '@/utils/directives'

import '@/styles/index.scss'
import '@/assets/fonts/iconfont.css'
import 'nprogress/nprogress.css'

import '@/icons' // svg-icon
import '@/permission' // permission control
import i18n from './lang' // internationalization

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
Vue.use(ElementUI, {
    locale,
    size: Cookies.get('size') || 'mini' // set element-ui default size
})

// 自定义表单
import CustomUpload from '@/components/formCreate/CustomUpload.vue'
import formCreate from '@form-create/element-ui'
formCreate.component('CustomUpload', CustomUpload)
Vue.use(formCreate)

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')
